import React, { useEffect, useRef, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom';
import { Link, withRouter } from 'react-router-dom'
import axios from 'axios';
import { getCookie, setCookie, removeCookie } from "../utiles/cookie";
import AlertDialogComponent from "../views/components/AlertDialogComponent";
import ConfirmDialogComponent from "../views/components/ConfirmDialogComponent";
import { decodeJwt } from "../utiles/cookie";
import { useTranslation } from 'react-i18next'
import { COMMON_LANG_TYPE } from '../modules/action/actionTypes';


const AppHeader = (props) => {
	const memberInfo = decodeJwt('codipai');
	const token = getCookie('codipai');
	const history = useHistory();
	const dispatch = useDispatch()
	const cancelRef = React.useRef();

	//alert
	const [showAlertDialog, setShowAlertDialog] = useState(false);
	const [alertDialogObject, setAlertDialogObject] = useState({ description: '', close: null })
	const [showConfirmDialog, setShowConfirmDialog] = useState(false);
	const [confirmDialogObject, setConfirmDialogObject] = useState({
		description: '',
		leftText: '',
		rightText: '',
		leftClick: null,
		rightClick: null
	})

	const [menuHover, setMenuHover] = useState(0);
	const [isGnb, setGnb] = useState(false);

	useEffect(() => {
		let path = location.pathname.split('/')[1]
		if (path != "" && document.getElementsByClassName(path).length > 0) {
			document.getElementsByClassName(path)[0].setAttribute('class', path + ' on')
		}
	}, [])


	/***********[translate]***************/
	const { t, i18n } = useTranslation(['page_header']);
	const langInfo = useSelector(state => state.common.Common_Lang_Type);	// ?? 'ko'

	useEffect(() => {
		const savedLang = sessionStorage.getItem('lang');// 로컬 스토리지에서 저장된 언어 설정을 가져옴
		if (!savedLang) {
			// 저장된 언어가 없으면 기본값으로 한국어('ko')를 설정하고 로컬 스토리지에 저장
			sessionStorage.setItem('lang', 'ko');
			dispatch({ type: COMMON_LANG_TYPE, Common_Lang_Type: 'ko' });
		} else {
			// 저장된 언어가 있으면 해당 언어로 설정
			dispatch({ type: COMMON_LANG_TYPE, Common_Lang_Type: savedLang });
			i18n.changeLanguage(savedLang);
		}
	}, []);
	
	useEffect(() => {
		// langInfo가 변경될 때마다 i18n 언어 설정을 업데이트
		if (langInfo !== undefined) {
			i18n.changeLanguage(langInfo);
		}
	}, [langInfo]);

	const onChangeLang = () => {
		const newLang = langInfo === 'ko' ? 'en' : 'ko';// 현재 언어가 한국어('ko')이면 영어('en')로, 영어이면 한국어로 변경
		// 언어 설정을 업데이트하고 로컬 스토리지에 저장
		dispatch({ type: COMMON_LANG_TYPE, Common_Lang_Type: newLang });
		sessionStorage.setItem('lang', newLang);
	}
	//****************************************/

	const funcMenuHover = (state, e) => {
		let coverUlchildA = e.target.parentElement.parentElement

		if (e.target.localName == 'a' && e.target.nextSibling != null && state == 1) {
			setMenuHover(1)
		}
		//하위 cover
		// else if (e.target.localName == 'ul' && e.target.className == 'gnb-child' && e.target.childElementCount > 0 && state == 1) {
		else if (e.target.className == 'gnb-child' && state == 1) {
			setMenuHover(1)
		}
		//하위 cover a
		// else if (coverUlchildA.localName == 'ul' && coverUlchildA.className == 'gnb-child' && coverUlchildA.childElementCount > 0 && state == 1) {
		else if (coverUlchildA.childElementCount > 0 && state == 1) {
			setMenuHover(1)
		}
		else {
			setMenuHover(0)
		}
	}


	// 드롭다운
	const modalRef = useRef(null);
	const [dropdown, setDropdown] = useState(false)
	const toggleDrop = e => {
		if (dropdown && (!modalRef.current || !modalRef.current.contains(e.target))) setDropdown(false)
	}
	useEffect(() => {
		window.addEventListener('click', toggleDrop);
		return () => {
			window.removeEventListener('click', toggleDrop);
		}
	})
	const onLogout = () => {
		setConfirmDialogObject({
			description: [t('로그아웃 하시겠습니까?')],
			leftText: t('취소'),
			rightText: t('확인'),
			leftClick: () => {
				setShowConfirmDialog(false);
			},
			rightClick: () => {
				setShowConfirmDialog(false);
				hadleLogout()
			},
		})
		setShowConfirmDialog(true)
	}
	const hadleLogout = () => {
		removeCookie('codipai');
		sessionStorage.clear();
		props.history.push({ pathname: '/' })//main page로 이동
		setGnb(false);
	}
	const changePage = (url) => {
		props.history.push(url);
		setGnb(false);
	}
	return (
		<>
			<header className={"header main " + (langInfo === 'ko' ? 'KR' : 'EN')}>
				<div className={menuHover === 1 ? "gnb-cover display" : "gnb-cover"} ></div>
				<div className="container">
					<div className="topmenu">
						<h1>
							<Link to="/"><img src="/images/logo2.svg" alt="logo" className="h1-logo" /></Link>
						</h1>
						<div className="gnb-area">
							<ul className='gnb' onMouseOver={(e) => funcMenuHover(1, e)} onMouseOut={(e) => funcMenuHover(0, e)} >
								<li>
									<Link to="/intro" className="intro">{t('소개')}</Link>
									<ul className={menuHover === 1 ? "gnb-child display" : "gnb-child"}>
										<li><Link to="/intro/greeting" id="greeting">{t('인사말')} </Link></li>
										<li><Link to="/intro/businessInfo" id="businessInfo">{t('사업 소개')}</Link></li>
										<li><Link to="/intro/performance" id="performance">{t('사업단 성과')}</Link></li>
										<li><Link to="/intro/agency" id="agency">{t('참여 기관')}</Link></li>
									</ul>
								</li>
								<li>
									<Link to="/data">{t('데이터')}</Link>
									<ul className={menuHover === 1 ? "gnb-child display" : "gnb-child"}>
										<li><Link to="/data">{t('데이터 현황')}</Link></li>
									</ul>
								</li>
								<li>
									<Link to="/safe-zone/info">{t('안심분석구역')}</Link>
									<ul className={menuHover === 1 ? "gnb-child display" : "gnb-child"}>
										<li><Link to="/safe-zone/info">{t('안심분석구역 소개')} </Link></li>
										<li><Link to="/safe-zone/procedure">{t('이용절차 안내')}</Link></li>
									</ul>
								</li>
								<li>
									<Link to="/market"> {t('S/W 마켓')}</Link>
									<ul className={menuHover === 1 ? "gnb-child display" : "gnb-child"}>
										<li><Link to="/market">{t('S/W 목록')} </Link></li>
										<li><Link to="/market/write">{t('신규등록')}</Link></li>
									</ul>
								</li>
								<li>
									<Link to="/board" className="notice">{t('공지사항')}</Link>
									<ul className={menuHover === 1 ? "gnb-child display" : "gnb-child"}>
										<li><Link to="/board/notice">{t('공지사항')}</Link></li>
									</ul>
								</li>
								<li>
									<Link to="/board/contactus" className="contactus">{t('문의하기')}</Link>
									<ul className={menuHover === 1 ? "gnb-child display" : "gnb-child"}>
										<li><Link to="/board/contactus">{t('문의하기')}</Link></li>
									</ul>
								</li>
							</ul>
							<div className="gnbSideBtns">
								{
									memberInfo && token ?
										// token ? 
										<>
											<div className={`user ${dropdown ? 'active' : 'off'}`} onClick={() => setDropdown(!dropdown)}>
												<span>{t('마이페이지')}</span>
												{dropdown &&
													<ul className="dropdown-list" ref={modalRef}>
														<li><Link to="/auth/mypage">{t('내정보')}</Link></li>
														<li><Link to="/safe-zone/list">{t('안심분석구역 신청현황')}</Link></li>
													</ul>
												}
											</div>
											<a className="logout" onClick={onLogout}></a>
										</>
										:
										<>
											{/* <Link to="/auth/terms">{t('회원가입')}</Link>*/}
											<Link to="/auth/login">{t('로그인')}</Link>
										</>
								}
								{/* <Link to="#" className="lang" onClick={onChangeLang}>{langInfo ==='ko'? 'KR' : langInfo ==='en' ? 'EN' : 'CN' }</Link> */}
								<a className="lang" onClick={onChangeLang}>{langInfo === 'ko' ? 'KR' : 'EN'}</a>
							</div>
						</div>
					</div>

					{
						showAlertDialog &&
						<AlertDialogComponent cancelRef={cancelRef} description={alertDialogObject.description}
							close={alertDialogObject.close} />
					}

					{
						showConfirmDialog &&
						<ConfirmDialogComponent cancelRef={cancelRef} description={confirmDialogObject.description}
							leftText={confirmDialogObject.leftText}
							rightText={confirmDialogObject.rightText}
							leftClick={confirmDialogObject.leftClick}
							rightClick={confirmDialogObject.rightClick} />
					}
				</div>
			</header>
		</>
	)

}

export default withRouter(AppHeader)
